// The height of the top section in the ViewerPlaybackControls FineTimeline.
// This shows the "legend" that has a tick mark every second.
// In addition, any tags in the capture are also shown here.
export const TICK_BAR_HEIGHT = 32;

// The height of each track in ViewerPlaybackControls FineTimeline.
// In non-MPI cases, there's only one track, but any time a MPI capture group is played back, there
// will be two tracks - one per capture shown in the DualCaptureViewer.
export const TRACK_HEIGHT = 128;

// The spacing between the last track in the ViewerPlaybackControls FineTimeline and the bottom of
// the component.
export const BOTTOM_MARGIN_HEIGHT = 8;

// The framerate at which captures play back, used to convert between frames and seconds.
export const CAPTURE_FRAMERATE_FPS = 30;

// The width of each event marker on the ViewerPlaybackControls FineTimeline. Used to determine when
// two events are overlapping each other.
export const TIMELINE_EVENT_MARKER_WIDTH_IN_PX = 22;

const FINE_TIMELINE_PIXELS_PER_SECOND = 25;

// Converts a logical timeline coordinate in seconds into the pixel position it should be drawn at.
export function coordinateToDisplay(seconds: number): number {
  return seconds * FINE_TIMELINE_PIXELS_PER_SECOND;
}

// Converts a pixel position into the logical timeline coordinate it represents.
export function displayToCoordinate(position: number): number {
  return position / FINE_TIMELINE_PIXELS_PER_SECOND;
}
